import { request } from 'src/api/request';
import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';

interface GetExportProps {
  fileType: string;
  fileName: string;
  columns: string[];
  searchParams: {
    page: number;
    pageSize: number;
    sort: any;
    order: any;
    q: string;
  };
}
export interface AddressSuggestionItem {
  id?: string;
  address_key: string;
  practice_name?: string;
  address_line_1: string;
  address_line_2?: string;
  city: string;
  state: string;
  zip_code: string;
  lat?: number;
  lng?: number;
  is_primary?: boolean;
  [key: string]: any;
}
export interface AddressSuggestionsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: AddressSuggestionItem[];
}

export interface EmailSuggestionItem {
  email: string;
  is_primary?: boolean;
  confidence?: number;
  [key: string]: any;
}

export interface EmailSuggestionsResponse {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results: EmailSuggestionItem[];
}

export const getExportDataIssues = async ({
  searchParams,
  fileType,
  fileName,
  columns,
}: GetExportProps) => {
  const { page, pageSize, sort, order, q } = searchParams;
  const queryParams = getSearchQueryParamsForAPI({
    sort,
    order,
    page: page + 1,
    pageSize,
    q,
  });

  const url = `https://api.medscout.io/api/v1/account/data-issues/${queryParams}`;

  return request({
    url: '/v1/admin/export/',
    method: 'POST',
    data: {
      url,
      file_format: fileType,
      columns: columns,
      file_name: fileName,
    },
  });
};

export const getDataIssueAddressSuggestions = async (url: string) => {
  const response = await request({ url, method: 'GET' });

  if (response?.results && Array.isArray(response.results)) {
    return {
      ...response,
      results: [...response.results].sort(
        (a, b) => Number(b.is_primary ?? 0) - Number(a.is_primary ?? 0)
      ),
    } as AddressSuggestionsResponse;
  }

  // Return default structure if response is not as expected
  return {
    count: 0,
    next: null,
    previous: null,
    results: [],
  } as AddressSuggestionsResponse;
};

export const getDataIssueEmailSuggestions = async (url: string) => {
  const response = await request({ url, method: 'GET' });

  if (response?.length > 0) {
    return {
      ...response,
      results: [...response].sort(
        (a, b) => Number(b.is_primary ?? 0) - Number(a.is_primary ?? 0)
      ),
    } as EmailSuggestionsResponse;
  }

  // Return default empty structure if response is not as expected
  return {
    count: 0,
    next: null,
    previous: null,
    results: [],
  } as EmailSuggestionsResponse;
};
